const scheduleCalendarStyle = {
  chipContainer: {
    display: 'flex',
    justifyContent: 'center',
    flexWrap: 'wrap',
  }
};

export default scheduleCalendarStyle;
